import { useEffect, useState } from "react";
import type { ToastTone } from "./Toast";

export function useToastNotification(message: string | null, tone: ToastTone) {
  const [notification, setNotification] = useState<{ message: string; tone: ToastTone } | null>(null);
  useEffect(() => {
    if (!message) {
      setNotification(null);
      return;
    }
    setNotification({ message, tone });
    // Errors stay available until dismissed or resolved; success/info are transient.
    if (tone === "error") return;
    const timeout = window.setTimeout(() => setNotification(null), 6000);
    return () => window.clearTimeout(timeout);
  }, [message, tone]);
  return { notification, dismiss: () => setNotification(null) };
}
